import React, { Component, createRef } from 'react';
import { func } from 'prop-types';
import { detectElement } from './helper';

export const AD_CLASS_NAME = 'adBanner';

/**
 *  This HOC will detect an adblock browser extension and pass a boolean
 *  `adBlockDetected` prop to use for conditional rendering.
 *
 * ```
 * {({ adBlockDetected }) => adBlockDetected ? null : <Component />}
 * ```
 *
 */
class DetectAdBlock extends Component {
  static propTypes = {
    children: func.isRequired
  };

  constructor(props) {
    super(props);

    this.state = {
      isAdBlockDetected: undefined
    };

    this.adBannerRef = createRef();
  }

  componentDidMount() {
    const isAdBlockDetected = detectElement(this.adBannerRef.current);

    // setState is okay here because we need to measure the DOM node
    //
    // eslint-disable-next-line react/no-did-mount-set-state
    this.setState({ isAdBlockDetected });
  }

  render() {
    const { isAdBlockDetected } = this.state;
    const { children } = this.props;

    return isAdBlockDetected === undefined ? (
      <div ref={this.adBannerRef} className={AD_CLASS_NAME} />
    ) : (
      children({ isAdBlockDetected })
    );
  }
}

export default DetectAdBlock;
